import { render, staticRenderFns } from "./Uploads.vue?vue&type=template&id=77e3c554"
import script from "./Uploads.vue?vue&type=script&lang=ts"
export * from "./Uploads.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77e3c554')) {
      api.createRecord('77e3c554', component.options)
    } else {
      api.reload('77e3c554', component.options)
    }
    module.hot.accept("./Uploads.vue?vue&type=template&id=77e3c554", function () {
      api.rerender('77e3c554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/requestDetails/Uploads.vue"
export default component.exports